import {UpmEntityType} from '@hconnect/common/types'
import {useMemo} from 'react'

import {CRUSHER_FLOW_CONFIG_NAME, CRUSHER_TERMINAL_NODE} from '../../consts/crushers'
import {deserializeSetups} from '../../flow/helpers'
import {useEntityConfig} from '../upmEntityConfig/useEntityConfig'

interface UseCrusherDeletionValidationResult {
  isUsedInCombination: boolean
  isLoading: boolean
  isError: boolean
}

export const useCrusherDeletionValidation = (
  plantUpmId: string,
  areaUpmId: string | undefined,
  crusherId: string | undefined
): UseCrusherDeletionValidationResult => {
  const {
    data: entityConfig,
    isLoading,
    isError
  } = useEntityConfig(plantUpmId, areaUpmId, UpmEntityType.Area)

  const isUsedInCombination = useMemo(() => {
    if (!entityConfig || !crusherId) return false

    const entry = entityConfig.payload.productionData.find(
      (d) => d.name === CRUSHER_FLOW_CONFIG_NAME
    )
    if (!entry) return false

    const setups = deserializeSetups(entry.value, CRUSHER_TERMINAL_NODE.id)
    return setups.some((setup) =>
      setup.links.some((link) => link.sourceNodeId === crusherId || link.targetNodeId === crusherId)
    )
  }, [entityConfig, crusherId])

  return {isUsedInCombination, isLoading, isError}
}
